import {
  INSERE_DADOS,
  CLEAR_ALL,
  CLEAR_2_TO_8,
  CLEAR_3_TO_8,
  CLEAR_4_TO_8,
  CLEAR_5_TO_8,
  CLEAR_6_TO_8,
  CLEAR_7_TO_8,
} from '../types';


export const insereDados = (name, value) => ({
  type: INSERE_DADOS,
  payload: {
    name,
    value,
  },
});
export const clear2to8 = () => ({
  type: CLEAR_2_TO_8,
});
export const clear3to8 = () => ({
  type: CLEAR_3_TO_8,
});
export const clear4to8 = () => ({
  type: CLEAR_4_TO_8,
});
export const clear5to8 = () => ({
  type: CLEAR_5_TO_8,
});
export const clear6to8 = () => ({
  type: CLEAR_6_TO_8,
});
export const clear7to8 = () => ({
  type: CLEAR_7_TO_8,
});

export const clearAll = () => ({
  type: CLEAR_ALL,
});
